export default function(obj) {
  const str = []
  for (const p in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, p) && obj[p] !== '') {
      if (Array.isArray(obj[p])) {
        obj[p].forEach(item => {
          str.push(encodeURIComponent(p) + '=' + encodeURIComponent(item))
        })
      } else {
        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
      }
    }
  }
  const query = str.join('&')
  return query ? '?' + query : ''
}
